import React from "react";
import { Box, Typography } from "@mui/material";
import RotatingReel from "../rotatingReel/RotatingReel";

const Partners = () => {
  return (
    <Box
      component="section"
      sx={{
        px: { xs: 2, md: 3 },
        position: "relative",
        overflow: "hidden",
        textAlign: "center",
        backdropFilter: "blur(10px)",
      }}
    >
      {/* Heading */}
      <Typography
        variant="h3"
        fontWeight={800}
        sx={{
          textAlign: "center",
          color: "var(--secondary-blue)",
          mb: { xs: 1.5, md: 1 },
          fontSize: { xs: "1.8rem", md: "2.5rem" },
        }}
      >
        Meet Our Partners
      </Typography>

      {/* Subheading */}
      <Typography
        variant="h4"
        fontWeight={600}
        sx={{
          textAlign: "center",
          color: "text.primary",
          mb: { xs: 3, md: 4 },
          fontSize: { xs: "1.1rem", md: "1.5rem" },
        }}
      >
        Delivering With the Best in the Industry
      </Typography>

      {/* Rotating logos reel */}
      <RotatingReel />

      {/* Description */}
      <Typography
        variant="subtitle1"
        sx={{
          fontSize: { xs: "0.9rem", md: "1rem" },
          color: "text.secondary",
          mb: { xs: 4, md: 6 },
          maxWidth: "70rem",
          mx: "auto",
          mt: 4,
          lineHeight: 1.7,
          textAlign: { xs: "justify", md: "center" }, // justify on mobile for better readability
        }}
      >
        We proudly collaborate with{" "}
        <strong>trusted global and local carriers</strong>—DHL, Purolator, UPS,
        and many more—to ensure every shipment arrives
        <strong> safely</strong>, <strong>on time</strong>, and in perfect
        condition. By partnering with industry leaders, we bring you unmatched
        <strong> reliability</strong>, <strong>speed</strong>, and{" "}
        <strong>value</strong> for your shipping needs.
        <br />
        <br />
        Whether it’s <strong>domestic parcels</strong>,{" "}
        <strong>cross-border freight</strong>, or{" "}
        <strong>international deliveries</strong>, our partner network gives
        your business the flexibility to choose the right balance of cost and
        transit time—every time.
      </Typography>
    </Box>
  );
};

export default Partners;
